import React from 'react';

export const UserLink = ({ id, email, name }) => {
  if (!email || !name) {
    return 'Unknown user';
  }
  return <a href={'mailto:' + email}>{name}</a>;
};
